import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BellOff } from "lucide-react";

interface QuietHoursProps {
  preferences?: {
    quietHoursStart?: string | null;
    quietHoursEnd?: string | null;
  } | null;
  onUpdate: (updates: Record<string, string>) => void;
}

export function QuietHours({ preferences, onUpdate }: QuietHoursProps) {
  return (
    <Card className="card-elevated border-none shadow-premium">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BellOff className="h-5 w-5" />
          Quiet Hours
        </CardTitle>
        <CardDescription>
          Don't receive notifications during these hours
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="quiet-hours-start">Start time</Label>
            <Input
              id="quiet-hours-start"
              type="time"
              value={preferences?.quietHoursStart ?? "22:00"}
              onChange={(e) => onUpdate({ quietHoursStart: e.target.value })}
              className="w-full"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="quiet-hours-end">End time</Label>
            <Input
              id="quiet-hours-end"
              type="time"
              value={preferences?.quietHoursEnd ?? "07:00"}
              onChange={(e) => onUpdate({ quietHoursEnd: e.target.value })}
              className="w-full"
            />
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Notifications will be held during quiet hours. Set both start and end times to enable.
        </p>
      </CardContent>
    </Card>
  );
}
